export const usePreDownload = (
  hooks: { hookName: string; hook: any }[]
): Record<string, any> => {
  const hooksResult = hooks.map((hook) => hook.hook);

  return {
    isLoading: hooksResult.some((hook) => hook.isLoading),
    isError: hooksResult.some((hook) => hook.isError),
    error: hooksResult.some((hook) => hook.error),
    ...hooks.reduce((acc: Record<string, any>, hook, index) => {
      const hookName: string = hook.hookName;
      const hookResult = hooksResult[index];
      acc[hookName] = hookResult;
      return acc;
    }, {}),
  };
};
